import {
  adminRequest,
  domiciliationRequest,
  juridiqueRequest,
  updateAdminRequest,
  updateDomiciliationRequest,
  updateJuridiqueRequest,
} from "../redux/actions/RequestActions";

// Business rules of the subscription flows (domiciliation, admin, legal)

export const OHADA_COUNTRIES = [
  "BJ",
  "BF",
  "CM",
  "CF",
  "KM",
  "CG",
  "CD",
  "CI",
  "GQ",
  "GA",
  "GN",
  "GW",
  "ML",
  "NE",
  "SN",
  "TD",
  "TG",
];

const ADMIN_TURNOVER_THRESHOLD = 50000000;
const ADMIN_RATE_ABOVE_THRESHOLD = 1.8;

export const adminPrices = (prices, turnover = 0) => {
  const rate =
    turnover < ADMIN_TURNOVER_THRESHOLD ? 1 : ADMIN_RATE_ABOVE_THRESHOLD;

  return { mensuel: prices.mensuel * rate, annuel: prices.annuel * rate };
};

// Request created at the options step of each flow, and its main service
export const FLOW_REQUESTS = {
  domiciliation: {
    mainKey: "domiciliation",
    storeKey: "domiciliationRequest",
    create: domiciliationRequest,
    update: updateDomiciliationRequest,
  },
  admin: {
    mainKey: "platformAdmin",
    storeKey: "adminRequest",
    create: adminRequest,
    update: updateAdminRequest,
  },
  juridique: {
    mainKey: "platformJuridique",
    storeKey: "juridiqueRequest",
    create: juridiqueRequest,
    update: updateJuridiqueRequest,
  },
};

export const companyCountry = (cart) =>
  (cart?.businessCountry || cart?.company?.country || "").toUpperCase();

export const companyTurnover = (cart) =>
  cart?.turnover || cart?.company?.turnover || 0;
